<template>
<div class="chapter">
<div class="inner_page">
<p class="ded"><span class="txit">For Bill Andrews,<br/>whose wonderful sense of humor and enthusiasm for the written word was and remains an inspiration.</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ded.vue?1001287c